import { backend } from 'modules/data';

export interface ActionsBlockProps {
    className?: string;
    customSaveAndSubmitRequest?: (commentText?: string, needToCompleteReview?: boolean) => void;
    customGetRequestTransfer?: () => backend.Transfer<backend.transfers.RequestEditTransfer>;
    customRequestValidationFn?: () => Promise<string[]>;
    onOpenImportFilePopup?: () => void;
    isSaving?: boolean;
    isImportFileButtonHidden?: boolean;
}

export interface ResubmitRequestParams {
    commentText: string;
    needToCompleteReview?: boolean;
    isOverwriteRequest?: boolean;
}

export enum SubmitRequestType {
    Resubmit = 'Resubmit',
    SaveAndApprove = 'SaveAndApprove',
}
